module.exports = __webpack_public_path__ + "img/xddqsea-currency-guide-th.9effdcbb.png";